import * as React from 'react';

import { InlineLabel, StackedCell } from '@klareospace/pharos-lib-web-utils';

import { ShipperAvatar } from '&/features/settings/shippers';

// ─── Types ────────────────────────────────────────────────────────────────────

interface OrderNumberCellProps {
  referenceNumber: string;
  shipperLogo: string;
  shipperName: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function OrderNumberCell({
  referenceNumber,
  shipperLogo,
  shipperName,
}: OrderNumberCellProps): React.JSX.Element {
  return (
    <StackedCell
      primary={<span className="text-sm font-medium">{referenceNumber}</span>}
      secondary={
        <InlineLabel
          labelClassName="text-muted-foreground"
          prefix={<ShipperAvatar className="w-3.5 h-3.5" logoUrl={shipperLogo} name={shipperName} />}
          size="xs"
        >
          {shipperName}
        </InlineLabel>
      }
    />
  );
}
